import * as React from "react"

import { cn } from "../../lib/utils"

export type TextAreaProps = React.ComponentProps<"textarea"> & { 
  label?: string, 
  error?: string,
  iconOrTextPosition?: "left" | "right"; 
  iconOrText?: React.ReactNode | string;
};

function TextArea({ error, label, className, iconOrText, iconOrTextPosition, required, ...props }: TextAreaProps) {
  return (
    <div className="flex flex-col w-full gap-2">
      {label && (
        <p>
          {label} {required && <span className="text-destructive">*</span>}
        </p>
      )}
      <div className="relative w-full">
        <textarea
          data-slot="input"
          className={cn(
            iconOrTextPosition ? iconOrTextPosition === "right" ? "pr-10" : "pl-10" : "", 
            "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-11 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-background-input-gray disabled:border disabled:border-border-input-gray disabled:text-gray-500  md:text-sm",
            "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
            "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
            className
          )}
          {...props}
        />
        {iconOrText && iconOrTextPosition === "left" && (
        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
          {iconOrText}
        </span>
      )}

      {iconOrText && iconOrTextPosition === "right" && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
          {iconOrText}
        </span>
      )}
      </div>
      {error && (
        <span className="text-red-500 text-sm">
          {error}
        </span>
      )}
    </div>
  )
}

export { TextArea }
